import { render, staticRenderFns } from "./EventLogs.vue?vue&type=template&id=23efce73&scoped=true"
import script from "./EventLogs.vue?vue&type=script&lang=js"
export * from "./EventLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23efce73",
  null
  
)

export default component.exports